import React, { useState, useEffect } from "react";
import axios from "axios";
import { __API_URL__ } from "../../SERVER_URL";
import useUser from "../../hooks/user";
import Table from "react-bootstrap/Table";

const Photographic_App_Before_Injection = (props) => {
  const [value, newValue] = React.useState("list");
  const token = localStorage.getItem("token");
  const user_data = JSON.parse(localStorage.getItem("user_data"));
  const role = user_data.role;
  const setMessage = props.setMessage;
  const setTypeOfMessage = props.setTypeOfMessage;
  let disable = false;
  const [selectedBlock, setSelectedBlock] = useState({});
  const user = useUser();

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setSelectedBlock((selectedBlock) => ({
      ...selectedBlock,
      [name]: value,
    }));
    props.setHasChanged(true);
  };

  const handleInstruction = (e) => {
    setSelectedBlock({
      ...selectedBlock,
      is_instruction: !selectedBlock.is_instruction,
    });
    props.setHasChanged(true);
  };
  const handleTrained = (e) => {
    setSelectedBlock({
      ...selectedBlock,
      is_trained: !selectedBlock.is_trained,
    });
    props.setHasChanged(true);
  };
  const handleBeforeInjection = (e) => {
    setSelectedBlock({
      ...selectedBlock,
      is_before_injection: !selectedBlock.is_before_injection,
    });
    props.setHasChanged(true);
  };

  const GetSelectedBlockData = () => {
    axios
      .get(
        `${__API_URL__}/api/ecrf/get_photographic_app_before/${props?.trialId}/?patient_id=${props?.patient_id}&visit_number=${props?.visit_number}&sessionId=${props?.selectedSessionId}`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      )
      .then((res) => {
        setSelectedBlock(res.data);
      })
      .catch((err) => {
        if (err === "Error: Request failed with status code 401") {
        }
      });
  };

  const AllVisitsData = () => {
    const createData = {
      patient_id: props?.patient_id,
      visit_number: props?.visit_number,
      ...selectedBlock,
      is_instruction:
        selectedBlock?.is_instruction === undefined ? true : selectedBlock?.is_instruction,
      is_trained: selectedBlock?.is_trained === undefined ? true : selectedBlock?.is_trained,
      is_before_injection:
        selectedBlock?.is_before_injection === undefined
          ? true
          : selectedBlock?.is_before_injection,
      sessionId: props.selectedSessionId,
    };
    axios
      .patch(
        `${__API_URL__}/api/ecrf/update_photographic_app_before/${props.trialId}/`,
        createData,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      )
      .then((res) => {
        setSelectedBlock(res.data);
        props.setModalVisitChangeShow(false);
        props.setHasChanged(false);
        setMessage("Block updated successfully");
        setTypeOfMessage("success");
        setTimeout(() => {
          document.getElementById("cusMessages").style.right = "2rem";
        }, 100);
        setTimeout(() => {
          document.getElementById("cusMessages").style.right = "-99rem";
        }, 3000);
      })
      .catch((err) => {
        if (err === "Error: Request failed with status code 401") {
          user.actions.logout();
        }
        setMessage("Something Went Wrong");
        setTypeOfMessage("success");
        setTimeout(() => {
          document.getElementById("cusMessages").style.right = "2rem";
        }, 100);
        setTimeout(() => {
          document.getElementById("cusMessages").style.right = "-99rem";
        }, 3000);
      });
  };
  React.useEffect(() => {
    if (props?.patient_id && props?.photo_session) {
      GetSelectedBlockData();
    }
  }, []);
  return (
    <>
      {role === "CRO Admin" ||
      role === "Cro_coordinator" ||
      role === "Data Manager" ||
      props.patient_id === undefined
        ? (disable = true)
        : ""}
      <fieldset disabled={disable}>
        {props.photo_session || props.patient_id === undefined ? (
          <>
            {((props.patient_id !== undefined && role === "Investigator") ||
              role === "Inv_coordinator" ||
              selectedBlock.new_block === false) && (
              <div className="col-md-12 text-end">
                <button onClick={() => AllVisitsData()} className="btn btn-primary">
                  Update
                </button>
              </div>
            )}
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-9">
                  <p>
                    {" "}
                    • Were instructions to download and use the photographic app dispensed to the
                    participant at this visit?
                  </p>
                </div>
                <div className="col-md-1">
                  <p>
                    <small>
                      {" "}
                      Yes
                      <input
                        className="form-check-input mx-1"
                        type="radio"
                        name="is_instruction"
                        checked={selectedBlock?.is_instruction === true}
                        id="radio1"
                        value={selectedBlock?.is_instruction === true}
                        onChange={handleInstruction}
                      />
                    </small>
                  </p>
                </div>
                <div className="col-md-1">
                  <p>
                    <small>
                      {" "}
                      No
                      <input
                        class="form-check-input"
                        type="radio"
                        name="is_instruction"
                        checked={selectedBlock?.is_instruction === false}
                        id="radio1"
                        value={selectedBlock?.is_instruction === false}
                        onChange={handleInstruction}
                      />
                    </small>
                  </p>
                </div>
                {selectedBlock.is_instruction === false ? (
                  <div className="col-md-6">
                    <label> If No, indicate reason: </label>
                    <input
                      className="form-control"
                      type="text"
                      style={{ borderWidth: "1px" }}
                      name="instruction_reason"
                      id="flexSwitchCheckDefault"
                      value={selectedBlock.instruction_reason}
                      onChange={(e) => handleFieldChange(e)}
                    ></input>
                  </div>
                ) : (
                  ""
                )}
                <div className="col-md-9">
                  <p>
                    {" "}
                    • Was the participant trained on the first use of the photographic app on site
                    at this visit?
                  </p>
                </div>
                <div className="col-md-1">
                  <p>
                    <small>
                      {" "}
                      Yes
                      <input
                        className="form-check-input mx-1"
                        type="radio"
                        name="is_trained"
                        checked={selectedBlock?.is_trained === true}
                        id="radio1"
                        value={selectedBlock?.is_trained === true}
                        onChange={handleTrained}
                      />
                    </small>
                  </p>
                </div>
                <div className="col-md-1">
                  <p>
                    <small>
                      {" "}
                      No
                      <input
                        className="form-check-input mx-1"
                        type="radio"
                        name="is_trained"
                        checked={selectedBlock?.is_trained === false}
                        id="radio1"
                        value={selectedBlock?.is_trained === false}
                        onChange={handleTrained}
                      />
                    </small>
                  </p>
                </div>
                {selectedBlock.is_trained === false ? (
                  <div className="col-md-6">
                    <label> If No, indicate reason: </label>
                    <input
                      class="form-control"
                      type="text"
                      style={{ borderWidth: "1px" }}
                      name="trained_reason"
                      id="flexSwitchCheckDefault"
                      value={selectedBlock.trained_reason}
                      onChange={(e) => handleFieldChange(e)}
                    ></input>
                  </div>
                ) : (
                  ""
                )}
                <div className="col-md-9">
                  <p>
                    {" "}
                    • Was the photography performed by the participant before injection for each
                    target lesion at this visit?
                  </p>
                </div>
                <div className="col-md-1">
                  <p>
                    <small>
                      {" "}
                      Yes
                      <input
                        className="form-check-input mx-1"
                        type="radio"
                        name="is_before_injection"
                        checked={selectedBlock?.is_before_injection === true}
                        id="radio1"
                        value={selectedBlock?.is_before_injection === true}
                        onChange={handleBeforeInjection}
                      />
                    </small>
                  </p>
                </div>
                <div className="col-md-1">
                  <p>
                    <small>
                      {" "}
                      No
                      <input
                        className="form-check-input mx-1"
                        type="radio"
                        name="is_before_injection"
                        checked={selectedBlock?.is_before_injection === false}
                        id="radio1"
                        value={selectedBlock?.is_before_injection === false}
                        onChange={handleBeforeInjection}
                      />
                    </small>
                  </p>
                </div>
                {selectedBlock.is_before_injection === false ? (
                  <div className="col-md-6">
                    <label> If No, indicate reason: </label>
                    <input
                      class="form-control"
                      type="text"
                      style={{ borderWidth: "1px" }}
                      name="before_injection_reason"
                      id="flexSwitchCheckDefault"
                      value={selectedBlock.before_injection_reason}
                      onChange={(e) => handleFieldChange(e)}
                    ></input>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        ) : (
          "Visit is not started"
        )}
      </fieldset>
    </>
  );
};
export default Photographic_App_Before_Injection;
